import { useContextSelector } from 'use-context-selector'
import { SideFilterSelectContext } from './SideFilterSelectContext'
import LinearProgress from '@mui/material/LinearProgress'

export function SideFilterSelectLoading(): JSX.Element {
  const loading = useContextSelector(SideFilterSelectContext, (s) => s.loading)
  if (loading) return <LinearProgress />
  return <div />
}
